import axios from "axios";
import Cookies from "js-cookie";

/**
 * Setup global axios interceptors to handle authentication errors
 * This catches 401/403 responses from any axios request and automatically
 * logs out the user and redirects to the login page
 */
const setupInterceptors = () => {
  // Add response interceptor to global axios instance
  axios.interceptors.response.use(
    (response) => {
      // If response is successful, just return it
      return response;
    },
    (error) => {
      // Check if error is due to authentication failure (401 or 403)
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        // Clear all authentication tokens and session data
        Cookies.remove("Biodit");
        Cookies.remove("loc");
        localStorage.removeItem("loc");
        localStorage.removeItem("session");
        localStorage.removeItem("level");

        // Remove auth header
        delete axios.defaults.headers.common["Authorization"];

        // Stop token expiration checker if it exists
        // Note: We import dynamically to avoid circular dependency issues
        import("./tokenExpirationChecker").then((module) => {
          module.default.stop();
        });

        // Redirect to login page
        // Using window.location.href for a full page reload to clear app state
        window.location.href = "/login";
      }

      // Return the error for further handling if needed
      return Promise.reject(error);
    }
  );
};

export default setupInterceptors;
